import React from 'react';
import PropTypes from 'prop-types';
import ImageField from './imageField';
import ErrorDisplay from '../shared/errorDisplay';

const PhotosArea = props => {
  const errorOutput = {
    'rotate-image':
      'There was an error when attempting to rotate the image. Please try again.',
    'network-cropper':
      'There was an error cropping the image. Please try again.',
    'autoOrient-image':
      'There was an error when attempting to auto-orient the image. Please try again.',
    'invalid-image-format': 'The selected file type is not supported. Please select a file type of jpg or png.',
  };

  return (
    <div className="inpt img-inpt">
      <p className="desc">
        {props.isLeader
          ? props.translations['add-photos']
          : props.translations['personalize-comment']}
      </p>
      <span className="req">{props.translations.optional}</span>
      {props.error &&
        props.imageInputErrorCodes.indexOf(props.error) !== -1 && (
          <ErrorDisplay errorMessage={props.translations[props.error]} />
        )}
      {props.error &&
        Object.prototype.hasOwnProperty.call(errorOutput, props.error) && (
          <ErrorDisplay errorMessage={errorOutput[props.error]} />
        )}
      <div className="photos">
        <ImageField
          translations={props.translations}
          image={
            props.isLeader
              ? props.comment.comment.input.image1
              : props.comment.comment.input.image
          }
          uploadImage={props.uploadImage}
          imageLoading={props.imageLoading}
          uploadedImage={props.uploadedImages[0]}
          deleteUploadedPhoto={props.deleteUploadedPhoto}
          rotatePhoto={props.rotatePhoto}
          displayModal={props.displayModal}
          imageFieldNumber={0}
        />

        {props.isLeader && (
          <ImageField
            translations={props.translations}
            image={props.comment.comment.input.image2}
            uploadImage={props.uploadImage}
            imageLoading={props.imageLoading}
            uploadedImage={props.uploadedImages[1]}
            deleteUploadedPhoto={props.deleteUploadedPhoto}
            rotatePhoto={props.rotatePhoto}
            displayModal={props.displayModal}
            imageFieldNumber={1}
          />
        )}

        {props.isLeader && (
          <ImageField
            translations={props.translations}
            image={props.comment.comment.input.image3}
            uploadImage={props.uploadImage}
            imageLoading={props.imageLoading}
            uploadedImage={props.uploadedImages[2]}
            deleteUploadedPhoto={props.deleteUploadedPhoto}
            rotatePhoto={props.rotatePhoto}
            displayModal={props.displayModal}
            imageFieldNumber={2}
          />
        )}
      </div>
      <p className="hint">* {props.translations['max-file-size']}</p>
      <p className="hint disclaimer">* {props.translations['media-disclaimer']}</p>

      {props.isLeader && (
        <p className="hint">
          <span>* {props.translations['no-photos']}</span>
          <span> {props.translations['add-related-photos']}</span>
        </p>
      )}

    </div>
  );
};

PhotosArea.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  comment: PropTypes.shape({
    comment: PropTypes.shape({
      input: PropTypes.shape({
        image: PropTypes.shape({}),
        image1: PropTypes.shape({}),
        image2: PropTypes.shape({}),
        image3: PropTypes.shape({}),
      }),
    }),
  }).isRequired,
  imageInputErrorCodes: PropTypes.array.isRequired,
  imageLoading: PropTypes.number.isRequired,
  uploadImage: PropTypes.func.isRequired,
  displayModal: PropTypes.func.isRequired,
  uploadedImages: PropTypes.array,
  error: PropTypes.string,
  deleteUploadedPhoto: PropTypes.func,
  isLeader: PropTypes.bool,
  rotatePhoto: PropTypes.func,
};

PhotosArea.defaultProps = {
  uploadedImages: [],
  error: '',
  deleteUploadedPhoto: () => {},
  isLeader: false,
  rotatePhoto: () => {},
};

export default PhotosArea;
